import InstanceApi from "@/services/apiClient.js";
import ModalConfirm from "@/components/Modal/ModalConfirm.vue";

export default {

    components: {
        ModalConfirm,
    },

    data() {
        return {
          showModalConfirm: false,
          modalContentConfirm: "<div class='ModalInfo-ComfirmText'><p>Voulez-vous vraiment supprimer votre panier ?</p></div>",
        };
    },

    methods: {
        
        updateConsents() {
            this.clearQuote()
        },

        openModalConfirm() {
            this.showModalConfirm = true;
        },
      
        closeModalConfirm() {
            this.showModalConfirm = false;
        },

        // Clear Quote
        async clearQuote() {

            try {
                let apiUrlClearQuote = "mcp/cart/emptyquote";
                const response = await InstanceApi.get(apiUrlClearQuote);
                location.reload();
            } catch (error) {
                this.$fire({
                    title: "Oups",
                    text: "Une erreur est survenu lors de la supression de l'item du panier",
                    type: "error",
                    timer: 1500,
                    position: "top-end",
                });
            }
        },
    },
};
